import type { ButtonHTMLAttributes } from "react"

const variants: Record<string, string> = {
  primary: "bg-blue-600 text-white hover:bg-blue-700 border-blue-600",
  secondary: "bg-white border-slate-200 text-slate-700 hover:bg-slate-50",
  ghost: "bg-transparent border-transparent text-slate-600 hover:bg-slate-100",
  danger: "bg-red-100 text-red-700 hover:bg-red-200 border-red-200",
  "danger-solid": "bg-red-600 text-white hover:bg-red-700 border-red-600",
  outline: "bg-white border-blue-600 text-blue-600 hover:bg-blue-50",
}

const sizes: Record<string, string> = {
  sm: "px-3 py-1 text-xs",
  md: "px-4 py-2 text-sm",
  lg: "px-6 py-2.5 text-sm",
}

export function Button({
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: keyof typeof variants
  size?: "sm" | "md" | "lg"
}) {
  return (
    <button
      className={`inline-flex items-center justify-center font-bold rounded-md border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}
